import { supabase } from './supabaseClient';

export class DeepseekChatClient {
  static async sendMessage(sessionId, message, attachments = [], language = 'en', cvInfo = null) {
    const { data, error } = await supabase.functions.invoke('deepseek-chat-assistant', {
      body: {
        session_id: sessionId,
        message,
        attachments,
        language,
        cv_info: cvInfo, // Include CV information for context persistence
      },
    });
    if (error) throw error;
    return data;
  }
}

export default DeepseekChatClient;

